import React from "react";
import { motion } from "framer-motion";

/**
 * WorkflowBar13 — barre de progression signature WYVIO.
 * Deux variantes :
 *   • "soft"  (défaut) — fond clair. Segments passés #B8B8B0, actif #151515 pulsant, à venir #E8E8E2.
 *   • "lime"           — fond sombre. Segments passés #C8FF2F, actif lime pulsant, à venir rgba(255,255,255,0.10).
 * Le vert n'est utilisé QUE dans la variante lime (hero sombre).
 */
export function WorkflowBar13({
  total = 13,
  completed = 5,
  activeAt = null,
  variant = "soft",
  className = "",
  compact = false,
  testid,
}) {
  const active = activeAt ?? completed;

  const styles =
    variant === "lime"
      ? {
          done: "#C8FF2F",
          active: "#C8FF2F",
          upcoming: "rgba(255,255,255,0.10)",
          pulse: true,
        }
      : {
          done: "#B8B8B0",
          active: "#151515",
          upcoming: "#E8E8E2",
          pulse: true,
        };

  return (
    <div
      data-testid={testid}
      className={`flex w-full items-center ${compact ? "gap-[3px]" : "gap-[4px]"} ${className}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={completed}
    >
      {Array.from({ length: total }).map((_, i) => {
        const isDone = i < completed;
        const isActive = i === active;
        return (
          <motion.div
            key={i}
            initial={{ opacity: 0, scaleX: 0.4 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{
              delay: 0.04 * i,
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1],
            }}
            className={`h-1.5 flex-1 rounded-full ${
              isActive && styles.pulse && variant === "lime"
                ? "wyvio-segment-active"
                : ""
            }`}
            style={{
              background: isActive
                ? styles.active
                : isDone
                  ? styles.done
                  : styles.upcoming,
              transformOrigin: "left",
            }}
          />
        );
      })}
    </div>
  );
}
